import classNames from "@casino/external/classNames";
import type SettingsProps from "../types/SettingsProps";

const getButtonVariants = ({
  variant,
  disabled,
  animation,
}: Pick<SettingsProps, "variant" | "disabled" | "animation">): string => {
  if (variant === "secondary" || variant === "outline") {
    return animation === "error"
      ? classNames(
          "text-destructive bg-transparent ring-inset ring-1 ring-destructive",
          !disabled && "hover:bg-destructive/8",
        )
      : classNames(
          "text-foreground bg-transparent ring-inset ring-1 ring-secondary",
          !disabled && "hover:ring-foreground",
        );
  }
  if (variant === "tertiary") {
    return animation === "error"
      ? "text-white bg-destructive"
      : "text-white bg-muted";
  }
  if (variant === "ghost") {
    return animation === "error"
      ? classNames(
          "text-destructive bg-transparent",
          !disabled && "hover:bg-destructive/8",
        )
      : classNames(
          "text-muted-foreground bg-transparent",
          !disabled && "hover:text-foreground",
        );
  }
  return animation === "error"
    ? "text-white bg-destructive"
    : "text-white bg-primary";
};

export default getButtonVariants;
